import { Local } from 'modules/reporting/raw';
import { RouteObject } from 'react-router';

export default {
  path: 'raw',
  element: <Local />,
} as RouteObject;
